import React from 'react'

import logout from './reducers/logout'
import loginFailure from './reducers/loginFailure'
import loginSuccess from './reducers/loginSuccess'
import handleUserData from './reducers/handleUserData'

export const LOGIN_START = 'LOGIN/START';
export const LOGIN_CLEAR = 'LOGIN/CLEAR';
export const LOGIN_SESSION = 'LOGIN/SESSION';
export const LOGIN_REQUEST = 'LOGIN/REQUEST';
export const LOGIN_SUCCESS = 'LOGIN/SUCCESS';
export const LOGIN_FAILURE = 'LOGIN/FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT/REQUEST';

export const initialState = {
  data: null,
  logged: false,
  logging: true,
  message: "Logging...",
  submited: false,
  success: false,
};

export function reducer(state, action){
  const { type, payload } = action
  switch(type) {
    case LOGIN_CLEAR: 
      return {
        ...state, 
        logged: false, 
        logging: false, 
        message: "",
        success: false,
      }
    case LOGIN_START: 
      return {
        ...state, 
        logging: true, 
        message: "",
        submited: true
      }
    case LOGIN_SESSION: 
      return handleUserData(state, payload)
    case LOGIN_SUCCESS: 
      return loginSuccess(state, payload)
    case LOGIN_FAILURE: 
      return loginFailure(state, payload)
    case LOGOUT_REQUEST: 
      return logout(state, payload)
    default:
      return state;
  }
};